import React from "react";
import { useField } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

export const iconsEnum = {
  1: "camper",
  2: "car",
  3: "van",
  4: "trailer",
  5: "normal",
  6: "small",
  7: "little",
  8: "medium",
  9: "large",
  10: "home",
  11: "tree-house",
  12: "tent",
  13: "bed",
  14: "truck",
  15: "tent-3d",
  16: "parking",
  17: "pillow",
  18: "small-bed",
  19: "marquee",
  20: "bus",
};

export default function IconSelect({ value, changeCallback, editMode, color }) {
  const [open, setOpen] = React.useState(!editMode);

  return (
    <div className="d-flex align-items-center justify-content-center position-relative category-colors flex-wrap w-100 mb-3">
      <button
        className={`btn btn-light text-dark border border-dark d-flex align-items-center justify-content-center w-100`}
        type="button"
        onClick={() => setOpen(!open)}
      >
        <div
          className={`rounded-circle shadow-sm mr-2 ui-color-bulb border border-dark d-flex justify-content-center align-items-center`}
        >
          <i
            className={`campicon-${iconsEnum[value]}`}
            style={{ color: color }}
          ></i>
        </div>
        <span>Icon auswählen</span>
        <FontAwesomeIcon icon={faChevronDown} size="sm" className="ml-2" />
      </button>
      {open && (
        <div
          className="d-flex bg-white shadow-sm border w-auto p-2 rounded flex-wrap mt-2"
          style={{ zIndex: 20 }}
        >
          {Object.entries(iconsEnum).map(([enum_val, iconname]) => (
            <div
              key={enum_val}
              className={`rounded p-1 shadow-sm m-1 ui-icon-bulb ${
                value === enum_val ? "active" : ""
              }`}
              onClick={() => {
                changeCallback(enum_val);
                setOpen(false);
              }}
            >
              <i
                className={`h2 campicon-${iconname}`}
                style={{ color: color }}
              ></i>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function FormIconSelect({ name, editMode, color, onChange = null }) {
  const [field, meta, helpers] = useField(name);
  const { value } = field;
  const { setValue } = helpers;

  return (
    <>
      <IconSelect
        value={value}
        changeCallback={onChange ?? setValue}
        editMode={editMode}
        color={color}
      />
      {meta.touched && meta.error && (
        <span className="text-danger">{meta.error}</span>
      )}
    </>
  );
}
